import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";
import React from "react";

const useStyles = makeStyles()(() => ({
	table: {
		tableLayout: "fixed",
		width: "100%",
	},
	tableHead: {
		backgroundColor: "#D2D2D9",
		border: "0.5px solid",
	},
	tableHeadPrint: {
		backgroundColor: "#D2D2D9",
		border: "0.5px solid",
		display: "table-row-group",
	},
	userCell: {
		width: "12vw !important",
		minWidth: "12vw !important",
		maxWidth: "15vw !important",
		padding: "16px !important",
	},
	noDataTableRow: {
		borderBottom: "none !important",
	},
	tableBody: {
		border: "0.5px solid",
	},
}));

function getCellClass(header, classes) {
	if (header === "User") {
		return classes.userCell;
	}
	return "";
}

function CommonTable({ data = [], headers = [], columns = [], isPrint }) {
	const { classes } = useStyles();

	return (
		<Table className={classes.table}>
			<TableHead
				className={isPrint ? classes.tableHeadPrint : classes.tableHead}
			>
				<TableRow>
					{headers.map((header) => (
						<TableCell
							key={header}
							className={getCellClass(header, classes)}
						>
							{header}
						</TableCell>
					))}
				</TableRow>
			</TableHead>
			<TableBody className={classes.tableBody}>
				{data?.length === 0 ? (
					<TableRow>
						<TableCell className={classes.noDataTableRow}>
							No Records Found
						</TableCell>
					</TableRow>
				) : (
					data?.map((row) => (
						<TableRow key={row.createdDateTime + row.userName}>
							{columns.map((column, i) => (
								<TableCell
									key={column}
									className={getCellClass(headers[i], classes)}
								>
									{row[column]}
								</TableCell>
							))}
						</TableRow>
					))
				)}
			</TableBody>
		</Table>
	);
}

export default CommonTable;
